import { useBulkJobsStore } from '@/state/bulkJobs.store';

/**
 * Returns whether a specific row key has a pending bulk action in flight.
 *
 * Unit C — pending-row: drives opacity-70 + aria-busy="true" on <tr>.
 * UX divergences #2 (opacity-70) and #6 (aria-busy on <tr>, not per-row aria-live).
 *
 * @param rowKey - The entity key (e.g. asset.key, risk.key) to check.
 * @returns `true` when a non-suppressed queued/running bulk job includes this key.
 */
export function useRowPendingState(rowKey: string): boolean {
  return useBulkJobsStore(state => state.isKeyPending(rowKey));
}
